import React from "react";
import { FormControl } from "react-bootstrap";
import { InputCheckbox } from "./../../gui_components/UIComponents.js";
import { LogicConstants } from "../../ds/LogicConstants.js";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../../AppContext.js";
import {
  AddIcon,
  CancelIcon,
  DropDwnDown,
  DropDwnUp,
} from "../../gui_components/Icons.js";
import { GenericAttributeLookupHandler } from "../../lookup/GenericAttributeLookupHandler.js";
import {
  AddressBean,
  AttributeCacheBean,
  PageListBean,
  RestEntityUnLockRequest,
  RestReadRequest,
  RestRoleListRequest,
  RestRoleSearchCriteria,
  RestUserListRequest,
  UserBean,
  UserRoleBean,
  UserSearchCriteria,
} from "./../../ds/ds.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ShowError,
} from "./../../gui_components/UIComponents.js";
import { UserLookupHandler } from "./../../lookup/UserLookupHandler.js";
import { BaseToolBar, Loader, ModuleToolBar } from "./../BaseModule.js";

import { NEW_ENTRY } from "../../ds/App_Constants.js";
import { BaseBean } from "../../ds/client_ds.js";
import { SecurityAccessManager } from "../../security/SecurityAccessManager.js";
import { PopupRoleModule } from "../ModuleUtil.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "./../../gui_components/Util.js";
import { SecurityService } from "./../../services/SecurityService.js";
import { UserService } from "./../../services/UserService.js";
class UserMaintenance extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      isListFormOpen: true,
      response: {},
      pageTitle: "User Maintenance",
      modeText: "",
      userData: new UserBean(),
      userRoleData: new UserRoleBean(),
      addressData: new AddressBean(),
      pageList: new PageListBean(),
      criteria: new UserSearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      attributeCache: new AttributeCacheBean(),
      isEntryFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],

      selectedNodeKey: "headerView",

      isShowModuleSearchContainer: false,
      userLookupHandler: null,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      disabled: false,
      isfetched: false,
      isResetView: true,
      loginTypeList: [],
      countries: [],
      cities: [],
      states: [],
      selectRoleList: new Array(),
      availableRoleList: new Array(),
      isShowUserRolePopup: false,
      isDisabledFields: false,
      isShowAlertLvl3: false,
      isViewMode: false,
      isReseted: false,
      isShowRoleModule: false,
      moduleForPopup: [],
      order: "",
      sortField: "",

      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),

      userData1: new UserBean(),
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "User Maintenance";
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;

    this.loadCacheDetails();

    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
    }
    this.setState({
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editUser(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isViewMode: false,
        isDisabledFields: true,
        disabled: true,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandlers();
    this.loadRolePageList();
  }
  initLookupHandlers = () => {
    let userLookupHandler = new UserLookupHandler(this.companyCode, "User");

    this.setState({
      userLookupHandler: userLookupHandler,
    });
  };

  loadCacheDetails = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    this.state.countries = [];
    let countries = attribute_cache.countries;
    countries.map((countryCode) => {
      this.state.countries.push(countryCode);
    });

    this.state.states = [];
    let states = attribute_cache.states;
    states.map((stateCode) => {
      this.state.states.push(stateCode);
    });

    this.state.cities = [];
    let cities = attribute_cache.cities;
    cities.map((cityCode) => {
      this.state.cities.push(cityCode);
    });
  };
  addNewEntry = () => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    const PREFERRED_LOGIN_TYPE = "G";
    let userData = new UserBean();
    let addressData = new AddressBean();
    let pageTitle = this.moduleCaption + " - NEW";
    userData.companyCode = this.companyCode;
    userData.address = addressData;
    userData.loginType = PREFERRED_LOGIN_TYPE;
    //userData.entityCode = this.companyCode;
    if (!isEmptyString(this.state.moduleKeyCode)) {
      userData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else userData.code = NEW_ENTRY;
    this.setState({
      userData: userData,
      addressData: addressData,
      pageTitle: pageTitle,
    });
    this.state.userData = userData;
    this.openEntryForm();
  };

  getLoginTypes = () => {
    let loginTypeList = [];
    let normal = new BaseBean();
    normal.code = LogicConstants.LOGIN_TYPE_NORMAL_USER;
    normal.description = "Normal User";
    loginTypeList.push(normal);

    let admin = new BaseBean();
    admin.code = LogicConstants.LOGIN_TYPE_ADMIN_USER;
    admin.description = "Admin";
    loginTypeList.push(admin);

    let customer = new BaseBean();
    customer.code = LogicConstants.LOGIN_TYPE_CUSTOMER_USER;
    customer.description = "Customer";
    loginTypeList.push(customer);

    let vendor = new BaseBean();
    vendor.code = LogicConstants.LOGIN_TYPE_VENDOR_USER;
    vendor.description = "Vendor";
    loginTypeList.push(vendor);

    let retail = new BaseBean();
    retail.code = LogicConstants.LOGIN_TYPE_RETAIL_USER;
    retail.description = "Retail";
    loginTypeList.push(retail);

    let emp = new BaseBean();
    emp.code = LogicConstants.LOGIN_TYPE_EMPLOYEE_USER;
    emp.description = "Employee";
    loginTypeList.push(emp);

    let sp = new BaseBean();
    sp.code = LogicConstants.LOGIN_TYPE_SALES_PERSON_USER;
    sp.description = "Sales Person";
    loginTypeList.push(sp);

    let dataportal = new BaseBean();
    dataportal.code = LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER;
    dataportal.description = "Data Portal";
    loginTypeList.push(dataportal);
    return loginTypeList;
  };

  openEntryForm = () => {
    let userData = this.state.userData;
    let loginTypeList = [];
    loginTypeList = this.getLoginTypes();
    this.setState({ loginTypeList: loginTypeList });

    this.setState({
      isListFormOpen: false,
      isEntryFormOpen: true,
      isShowSaveButton: true,
      isShowApproveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      disabled: false,
      isDisabledFields: false,
      isResetView: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        disabled: true,
      });
    }

    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({
        disabled: true,
      });
    }
  };
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    let userData = new UserBean();
    let userData1 = new UserBean();
    userData1.confirmPassword = "";
    this.setState({
      userData: userData,
      userData1: userData1,
      isListFormOpen: true,
      isEntryFormOpen: false,
      isShowSaveButton: false,
      isShowApproveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      moduleKeyCode: NEW_ENTRY,
      isShowModuleSearchContainer: false,
      disabled: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
      isReseted: false,
      isResetView: false,
      isMaintenanceMode: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      availableRoleList: new Array(),
      selectRoleList: new Array(),
    });
  };
  unlockUser = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;

    UserService.unLockUser(
      request,
      this.unlockUserResponse,
      this.unlockUserError
    );
  };
  unlockUserResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editUser(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockUserError = (error) => {
    ShowError("Error : ", error);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;

    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;

    this.loadUserPage();
  };
  loadUserPage = () => {
    let requestInput = new RestUserListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.UserRoleMaintenance_IsAccessible()) {
      UserService.getUserPageList(
        requestInput,
        this.loadUserResponse,
        this.loadUserError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadUserResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.userPageList) &&
      !isEmptyArray(response.data.userPageList.users)
    ) {
      const userList = response.data.userPageList.users;
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.userPageList.totalCount;
      pageList.currentPage = response.data.userPageList.currentPage;

      this.setState({
        isLoading: false,
        userList: userList,
        pageList: pageList,
      });
    }
  };
  loadUserError = (error) => {
    ShowError("Error : ", error);
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      //let errList = this.state.error_list;
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  filterUser = () => {
    this.loadPage(1);
  };

  resetFilteredUser = (criteria) => {
    criteria = new UserSearchCriteria();
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.userCode = "";
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    if (e.target.name == "userCode") {
      criteria["userCode"] = e.target.value;
      // criteria["roleCode"] = e.target.value;
    }
    this.setState({ criteria: criteria });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  clearError = () => {
    this.clearErrors();
  };
  clearErrors = () => {
    let errList = [];
    this.setState({ error_list: errList });
  };

  editUser = (code) => {
    // this.loadRolePageList();
    let readrequest = new RestReadRequest();
    readrequest.companyCode = this.companyCode;
    readrequest.code = code;
    readrequest.isLoadChildren = true;

    let isLockRequired = NEW_ENTRY === code ? false : true;
    readrequest.isLockRequired = isLockRequired;
    if (SecurityAccessManager.UserRoleMaintenanceView_IsAccessible()) {
      UserService.initUserModule(
        readrequest,
        this.readUserResponse,
        this.readUserError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readUserResponse = (response) => {
    // this.loadRolePageList();
    if (response.data != null) {
      if (response.data.lockResponse != null) {
        if (!isEmpty(response.data.lockResponse.errors)) {
          this.showErrorMessage(response.data.lockResponse);
          this.state.isViewMode = true;
        }
      }
      if (response.data.userResponse != null) {
        let userData = response.data.userResponse.user;
        let addressData = new AddressBean();
        if (userData != null) {
          let pageTitle = this.moduleCaption + " - EDIT";
          let moduleKeyCode = userData.code;
          this.state.userData = userData;
          let editRoleList = [];
          let roleList = this.state.roleList;
          if (
            userData.userRoles != null &&
            !isEmptyArray(userData.userRoles) &&
            !isEmptyArray(roleList)
          ) {
            userData.userRoles.map((list) => {
              roleList.map((rl) => {
                if (rl.code === list.roleCode) {
                  list.description = rl.description;
                  editRoleList.push(list);
                }
              });
            });

            userData.userRoles = editRoleList;
          }
          if (!isEmpty(userData.address)) addressData = userData.address;

          let userData1 = this.state.userData1;
          userData1.confirmPassword = userData.password;
          this.setState({
            userData: userData,
            pageTitle: pageTitle,
            isLoading: false,
            moduleKeyCode: moduleKeyCode,
            addressData: addressData,
            userData1: userData1,
          });
          this.isLocked = true;
          this.openEntryForm();
        } else {
          this.addNewEntry();
        }
      }
    }
  };
  readUserError = (error) => {
    ShowError("Error" + error);
  };
  loadRolePageList = () => {
    let criteria = new RestRoleSearchCriteria();
    let pageInput = new PageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPageNumber = 1;

    let listRequest = new RestRoleListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    SecurityService.getRolePageList(
      listRequest,
      this.loadRoleListPageResponse,
      this.loadRoleListPageError
    );
  };
  loadRoleListPageResponse = (response) => {
    let roleList = response.data.rolePageList.roles;
    if (!isEmptyArray(roleList)) {
      this.setState({ roleList: roleList });
    }
  };
  loadRoleListPageError = (error) => {
    ShowError("Error :", error);
  };
  saveUser = () => {
    let addressData = this.state.addressData;
    let userData = this.state.userData;
    userData.companyCode = this.companyCode;
    userData.address = addressData;
    console.log("userData..",userData);
    if (userData.isFetched) {
      if (SecurityAccessManager.UserRoleMaintenanceEdit_IsAccessible) {
        UserService.updateUser(
          userData,
          this.saveUserResponse,
          this.saveUserError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.UserRoleMaintenanceCreate_IsAccessible) {
        UserService.createUser(
          userData,
          this.saveUserResponse,
          this.saveUserError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  // updateUserResponse = (response) => {
  //   const userData = response.data.user;
  //   this.handleresponse(response.data);
  //   if (userData != null) {
  //     let pageTitle = this.moduleCaption + " - EDIT";
  //     this.setState({
  //       userData: userData,
  //       pageTitle: pageTitle,
  //     });

  //     this.editUser(userData.code, true);
  //   }
  // };
  saveUserResponse = (response) => {
     console.log("userData..response",response);
    this.handleresponse(response.data);
    if (!isEmpty(response.data && !isEmpty(response.data.user))) {
      const userData = response.data.user;

      if (userData != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          userData: userData,
          pageTitle: pageTitle,
        });
        if (!this.isLocked) {
          this.editUser(response.data.user.code);
        } else {
          this.code = userData.code;
          this.unlockUser(response.data.user.code);
        }
      }
    }
  };
  saveUserError = (error) => {
    this.setState({ isLoading: false });
    ShowError("Error : " + error);
  };
  save = () => {
    this.saveUser();
  };
  getModuleListView = () => {
    let userData = this.state.userData;
    if (userData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadUserPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockUser(userData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadUserPage();
    }
  };
  resetView = () => {
    let user_Data = this.state.userData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockUser(user_Data.code);
    } else {
      this.isLocked = false;
    }
    let userData = new UserBean();
    userData.confirmPassword = "";
    let userData1 = new UserBean();
    userData1.confirmPassword = "";
    this.setState({
      userData: userData,
      userData1: userData1,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      isShowAlert: false,
      disabled: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),
      availableRoleList: new Array(),
      selectRoleList: new Array(),
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();

    this.clearError();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
    let userData = this.state.userData;
  };
  moduleExit = () => {
    let userData = this.state.userData;
    if (userData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockUser(userData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };

  onChange = (e) => {
    let temp_userdata = this.state.userData;
    let userData1 = this.state.userData1;
    temp_userdata[e.target.name] = e.target.value;
    userData1[e.target.name] = e.target.value;
    let temp_addressData = this.state.addressData;
    // if (
    //   e.target.name == "address1" ||
    //   e.target.name == "address2" ||
    //   e.target.name == "city" ||
    //   e.target.name == "state" ||
    //   e.target.name == "country" ||
    //   e.target.name == "zip" ||
    //   e.target.name == "mobilePhone" ||
    //   e.target.name == "phone1" ||
    //   e.target.name == "phone2" ||
    //   e.target.name == "contactPerson" ||
    //   e.target.name == "fax" ||
    //   e.target.name == "email" ||
    //   e.target.name == "website"
    // ) {
    temp_addressData[e.target.name] = e.target.value;
    // }
    temp_userdata.address = temp_addressData;
    this.setState({
      userData: temp_userdata,
      addressData: temp_addressData,
      userData1: userData1,
    });
  };

   dpOnChange = (e) => {
    const user_data = this.state.userData;
    user_data[e.target.name] = e.target.value;
    if (user_data.isDataPortalUser === true) {
      /* set login type to dataPortal */
      // user_data.loginType = LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER;
      /* add role dp to user */
      const roleList = this.state.roleList;
     
      const _role = roleList.filter(
        (rl) => rl.code == LogicConstants.ROLE_DATA_PORTAL_CUSTOMER
      );

       const sp_role = roleList.filter(
        (rl) => rl.code == LogicConstants.ROLE_DATA_PORTAL_SALESPERSON
      );
      // console.log("_role", _role);
      if(user_data.loginType === LogicConstants.LOGIN_TYPE_CUSTOMER_USER){
      const role = new UserRoleBean();
      role.roleCode = LogicConstants.ROLE_DATA_PORTAL_CUSTOMER;
      role.userCode = user_data.code;
      if(!isEmptyArray(_role))
      role.description = _role[0].description;
      user_data.userRoles.push(role);
      } else if(user_data.loginType === LogicConstants.LOGIN_TYPE_SALES_PERSON_USER){
        const role = new UserRoleBean();
        role.roleCode = LogicConstants.ROLE_DATA_PORTAL_SALESPERSON;
        role.userCode = user_data.code;
        if(!isEmptyArray(sp_role))
        role.description = sp_role[0].description;
        user_data.userRoles.push(role);
      }
     
    } else {
      /* set login type to default */
      user_data.loginType = LogicConstants.LOGIN_TYPE_NORMAL_USER;
      /* remove role dp to user */
      const roles = [...user_data.userRoles];
      const _roles = roles.filter(
        (rl) => (rl.roleCode != LogicConstants.ROLE_DATA_PORTAL_CUSTOMER && rl.roleCode != LogicConstants.ROLE_DATA_PORTAL_SALESPERSON)
      );
      user_data.userRoles = _roles;
    }
    this.setState({
      userData: user_data,
    });
  };
  dpOnChange_old = (e) => {
    const user_data = this.state.userData;
    user_data[e.target.name] = e.target.value;
    if (user_data.isDataPortalUser === true) {
      /* set login type to dataPortal */
      user_data.loginType = LogicConstants.LOGIN_TYPE_DATA_PORTAL_USER;
      /* add role dp to user */
      const roleList = this.state.roleList;
      const _role = roleList.filter(
        (rl) => rl.code == LogicConstants.ROLE_DATA_PORTAL_CUSTOMER
      );
      const role = new UserRoleBean();
      role.roleCode = LogicConstants.ROLE_DATA_PORTAL_CUSTOMER;
      role.userCode = user_data.code;
      role.description = _role[1].description;
      user_data.userRoles.push(role);
    } else {
      /* set login type to default */
      user_data.loginType = LogicConstants.LOGIN_TYPE_NORMAL_USER;
      /* remove role dp to user */
      const roles = [...user_data.userRoles];
      const _roles = roles.filter(
        (rl) => (rl.roleCode != LogicConstants.ROLE_DATA_PORTAL_CUSTOMER && rl.roleCode != LogicConstants.ROLE_DATA_PORTAL_SALESPERSON)
      );
      user_data.userRoles = _roles;
    }
    this.setState({
      userData: user_data,
    });
  };
  errorCallBack = (error) => {
    ShowError(error);
  };
  openRolePopupForm = (e) => {
    if (e.detail <= 1) {
      this.setState({ isShowUserRolePopup: true });

      let criteria = new RestRoleSearchCriteria();
      let pageInput = new PageListBean();
      // pageInput.pageSize = 20;
      pageInput.currentPageNumber = 1;

      let listRequest = new RestRoleListRequest();
      listRequest.searchCriteria = criteria;
      listRequest.pageInput = pageInput;
      SecurityService.getRolePageList(
        listRequest,
        this.loadRollPageResponse,
        this.errorCallBack
      );
    }
  };
  loadRollPageResponse = (response) => {
    console.log("loadRollPageResponse response: ", response);
    let userData = this.state.userData;
    let selectRoleList = this.state.selectRoleList;
    if (!isEmpty(response.data) && !isEmpty(response.data.rolePageList)) {
      const availableRoleList = response.data.rolePageList.roles;
      if (!isEmptyArray(availableRoleList)) {
        // if (userData.isFetched && !isEmpty(userData.userRoles)) {
        if (!isEmpty(userData.userRoles)) {
          let userRoles = userData.userRoles;
          let user_Roles = [...userData.userRoles];
          user_Roles.map((role, i) => {
            let roleData = new BaseBean();
            roleData.code = role.roleCode;
            roleData.description = role.description;
            selectRoleList.push(roleData);
          });
          userRoles.map((rls, i) => {
            availableRoleList.map((rl, j) => {
              if (rls.roleCode == rl.code) {
                availableRoleList.splice(j, 1);
              }
            });
          });
        }
        this.setState({
          availableRoleList: availableRoleList,
          selectRoleList: selectRoleList,
        });
        // } else {
        // this.setState({ availableRoleList: availableRoleList });
        // }
      }
    }
  };
  closeAlertModalCallBackLvl3 = (isShowPopup) => {
    this.setState({
      isShowUserRolePopup: isShowPopup,
      // isShowAlert: isShowPopup,
      availableRoleList: new Array(),
      selectRoleList: new Array(),
    });
    // this.clearRoles();
  };

  selectRoll = (e, val, rowData) => {
    if (e.detail == 1) {
      let selectRoleList = this.state.selectRoleList;
      selectRoleList.push(rowData);
      let availableRoleList = this.state.availableRoleList;
      let avList = [];
      availableRoleList
        .filter((list) => list.code != rowData.code)
        .map((dataList) => avList.push(dataList));
      availableRoleList = avList;
      this.setState({
        selectRoleList: selectRoleList,
        availableRoleList: availableRoleList,
      });
    }
  };
  unSelectRoll = (e, val, rowData) => {
    if (e.detail == 1) {
      let availableRoleList = this.state.availableRoleList;
      availableRoleList.push(rowData);
      let selectRoleList = this.state.selectRoleList;
      let selList = [];
      selectRoleList
        .filter((list) => list.code != rowData.code)
        .map((dataList) => selList.push(dataList));
      selectRoleList = selList;
      this.setState({
        selectRoleList: selectRoleList,
        availableRoleList: availableRoleList,
      });
    }
  };
  addSelectedRolls = (e) => {
    if (e.detail == 1) {
      let selectRoleList = this.state.selectRoleList;
      let userData = this.state.userData;
      let roleList = [];
      selectRoleList.map((data, index) => {
        let userRoleData = new UserRoleBean();
        userRoleData.userCode = userData.code;
        userRoleData.roleCode = data.code;
        userRoleData.description = data.description;
        roleList.push(userRoleData);
      });
      userData.userRoles = roleList;
      this.setState({ userData: userData });
      this.closeAlertModalCallBackLvl3(false);
    }
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editUser(this.state.moduleKeyCode);
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowRoleModule: isOpen, moduleForPopup: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  lnkRoleModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowRoleModule: true,
          moduleForPopup: (
            <PopupRoleModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let userList = this.state.userList;
    if (sortField && !isEmptyArray(userList)) {
      const sorted = [...userList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ userList: sorted });
    }
  };

  /***lookup autocomplete */
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readCityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cities = this.state.cities;
      cities.map((ct) => {
        if (ct.code == e.target.value) {
          temp_addressData["city"] = ct.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;

    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;

      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readStateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let states = this.state.states;
      states.map((st) => {
        if (st.code == e.target.value) {
          temp_addressData["state"] = st.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      addressData: temp_addressData,
    });
  };
  readStateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let countries = this.state.countries;
      countries.map((cntr) => {
        if (cntr.code == e.target.value) {
          temp_addressData["country"] = cntr.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCountryBySearchString(searchString) {
    let stateData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        addressData: temp_addressData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  render() {
    let selectRoleList = [];
    if (!isEmptyArray(this.state.selectRoleList))
      selectRoleList = this.state.selectRoleList;
    let availableRoleList = [];
    if (!isEmptyArray(this.state.availableRoleList))
      availableRoleList = this.state.availableRoleList;

    let userData = this.state.userData;
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowRoleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <div>
          <ModuleToolBar
            isShowNewButton={false}
            onNewEntry={() => this.addNewEntry()}
            onModuleExit={() => this.moduleExit()}
            resetView={() => this.resetView()}
            pageTitle={this.state.pageTitle}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={this.state.isMaintenanceMode}
            onModuleKeyContainerButtonClick={this.editUser}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            getModuleListView={this.getModuleListView}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.userLookupHandler} //for f2 lookup
            showCriteriaDialog={true} //for f2 lookup
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            disabled={this.state.disabled}
            selectButtonClick={this.selectButtonClick}
            isSpecialViewMode={this.state.isSpecialViewMode}
            isResetView={this.state.isResetView}
          />
        </div>
        {!this.state.isListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              pageTitle={this.state.pageTitle}
              back={this.back}
              save={this.save}
              isShowSaveButton={this.state.isShowSaveButton}
              clearError={this.clearError}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
            />
          )}
        {this.state.isEntryFormOpen && (
          <UserMaintenanceEntryForm
            {...this.state}
            openRolePopupForm={this.openRolePopupForm}
            onChange={this.onChange}
            dpOnChange={this.dpOnChange}
            lnkRoleModule={this.lnkRoleModule}
            onCityChange={this.onCityChange}
            cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onStateChange={this.onStateChange}
            stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
            onCountryChange={this.onCountryChange}
            countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
            displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
          />
        )}
        {this.state.isListFormOpen && (
          <UserMaintenanceListForm
            {...this.state}
            filterUser={this.filterUser}
            loadFirst={this.loadFirst}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
            loadLast={this.loadLast}
            editUser={this.editUser}
            onChange={this.onCriteriaChange}
            resetFilteredUser={this.resetFilteredUser}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel3"}
          isModulePopup={false}
          lockScroll={true}
          isShowPopup={this.state.isShowUserRolePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl3}
          title={"Add Multiple Roll"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addSelectedRolls(e)}
              >
                Add
              </Button>
            </div>
          }
          content={
            <div className="usr-role-div">
              <div className="usr-role-tble">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th> </th>
                      <th>Role Code</th>
                      <th>Role Name</th>
                    </tr>
                  </thead>
                  {!isEmptyArray(availableRoleList) && (
                    <tbody>
                      {availableRoleList.map((list, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              variant="secondry"
                              onClick={(e) =>
                                this.selectRoll(e, list.code, list)
                              }
                            >
                              <AddIcon />
                            </Button>
                          </td>
                          <td>{list.code}</td>
                          <td>{list.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
              <div className="usr-role-tble">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th> </th>
                      <th>Role Code</th>
                      <th>Role Name</th>
                    </tr>
                  </thead>
                  {!isEmptyArray(selectRoleList) && (
                    <tbody>
                      {selectRoleList.map((list, index) => (
                        <tr key={index}>
                          {/* {list.isFetched == false ? ( */}
                          {!userData.isFetched ? (
                            <td>
                              <Button
                                variant="secondry"
                                onClick={(e) =>
                                  this.unSelectRoll(e, list.code, list)
                                }
                              >
                                <CancelIcon />
                              </Button>
                            </td>
                          ) : null}

                          {/* ) : (
                        <td></td>
                      )} */}
                          <td>{list.code}</td>
                          <td>{list.description}</td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
class UserMaintenanceListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new UserSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
  }

  onChange = (e) => {
    this.props.onChange(e);
  };
  filterUser = (e) => {
    if (e.detail == 1) this.props.filterUser();
  };
  resetFilteredUser = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetFilteredUser(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };

  editUser = (e, val) => {
    if (e.detail == 1) this.props.editUser(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterUser();
    }
  };
  render() {
    let userList = this.props.userList;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;

    let isLoading = this.props.isLoading;

    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="userCode"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.userCode}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />

              <span className="px-2"></span>
              <Button onClick={(e) => this.filterUser(e)}>Filter</Button>
              <span className="px-2"></span>
              <Button onClick={(e) => this.resetFilteredUser(e)}>Reset</Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  User
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>

                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {isLoading ? <Loader /> : null}
            {!isEmptyArray(userList) ? (
              <tbody>
                {userList.map((user, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editUser(e, user.code)}
                      >
                        {user.code}
                      </Button>
                    </td>
                    <td>{user.description}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {userList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class UserMaintenanceEntryForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
    this.userCodeRef = React.createRef();
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    if (this.userCodeRef.current != null) {
      this.userCodeRef.current.focus();
    }
  };
  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
  };
  render() {
    let userData = this.props.userData;
    let userData1 = this.props.userData1;
    let addressData = this.props.addressData;
    if (isEmpty(addressData)) {
      addressData = new AddressBean();
    }
    return (
      <div>
        <div className="header_div col-md-12 col-lg-12">
          <Row>
            <Col sm="1">
              <FormLabel>User Code </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.userCodeRef}
                onChange={this.props.onChange}
                name="code"
                value={userData.code}
                isMandatory={true}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>FirstName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="firstName"
                value={userData.firstName}
                disabled={this.props.isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>LastName </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="lastName"
                value={userData.lastName}
                disabled={this.props.isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel> UserName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="description"
                value={userData.description}
                isMandatory={true}
                disabled={this.props.isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Password</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="password"
                onChange={this.props.onChange}
                name="password"
                value={userData.password}
                isMandatory={true}
                disabled={this.props.isDisabledFields}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Confirm Password</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="password"
                onChange={this.props.onChange}
                name="confirmPassword"
                value={userData1.confirmPassword}
                isMandatory={true}
                disabled={this.props.isDisabledFields}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Employee Code</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="entityCode"
                value={userData.entityCode}
                disabled={this.props.isDisabledFields}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>CompanyCode</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="companyCode"
                value={userData.companyCode}
                disabled={true}
              />
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>SMTP UserName</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="smtpUserName"
                value={userData.smtpUserName}
                disabled={this.props.isDisabledFields}
              />
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>SMTP Password</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.props.onChange}
                name="smtpPassword"
                value={userData.smtpPassword}
                disabled={this.props.isDisabledFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>LoginType</FormLabel>
            </Col>
            <Col sm="2">
              <FormControl
                as="select"
                custom
                onChange={this.props.onChange}
                name="loginType"
                value={userData.loginType}
              >
                <option value=""></option>
                {this.props.loginTypeList.map((ln, i) => (
                  <option key={i} value={ln.code}>
                    {ln.description}
                  </option>
                ))}
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col className="align-items-left" sm="1">
              <FormLabel>Portal User</FormLabel>
            </Col>
            <Col className="align-items-left" sm="1">
              <InputCheckbox
                type="checkbox"
                name="portalUserFlag"
                checked={userData.portalUserFlag}
                onChange={this.props.onChange}
                disabled={this.props.isDisabledFields}
              />
            </Col>
            <Col className="align-items-left" sm="1">
              <FormLabel>Data Portal User</FormLabel>
            </Col>
            <Col className="align-items-left" sm="1">
              <InputCheckbox
                type="checkbox"
                name="isDataPortalUser"
                checked={userData.isDataPortalUser}
                onChange={this.props.dpOnChange}
                disabled={this.props.isDisabledFields}
              />
            </Col>
          </Row>
        </div>
        <div className="header_div col-md-12 col-lg-12">
          <div className="sales_grid_columns">
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>Address</FormLabel>
                </Col>
              </Row>
              {/* <div>Address</div> */}
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Address1</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="address1"
                    type="text"
                    placeholder="Enter Address"
                    onChange={this.props.onChange}
                    value={addressData.address1}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>City</FormLabel>
                </Col>
                <Col sm="5">
                  {/* <InputTextbox
                    onChange={this.props.onChange}
                    name="city"
                    placeholder="city"
                    value={addressData.city}
                    lookupRequired={true}
                    lookupHandler={this.state.cityLookupHandler}
                    disabled={this.props.isDisabledFields}
                  ></InputTextbox> */}
                  <InputTextbox
                    onChange={this.props.onCityChange}
                    name="city"
                    placeholder="city"
                    value={addressData.city}
                    lookupRequired={true}
                    lookupHandler={this.state.cityLookupHandler}
                    enterKeyEventHandler={this.props.cityEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.cityPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteCityList
                    }
                    showAutoCompleteList={this.props.showAutoCompleteCityList}
                    disabled={this.props.isDisabledFields}
                  ></InputTextbox>
                </Col>
              </Row>

              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>State</FormLabel>
                </Col>
                <Col sm="5">
                  {/* <InputTextbox
                    onChange={this.props.onChange}
                    name="state"
                    placeholder="state"
                    value={addressData.state}
                    lookupRequired={true}
                    lookupHandler={this.state.stateLookupHandler}
                    disabled={this.props.isDisabledFields}
                  ></InputTextbox> */}
                  <InputTextbox
                    name="state"
                    type="text"
                    placeholder="Enter state"
                    value={addressData.state}
                    onChange={this.props.onStateChange}
                    lookupRequired={true}
                    lookupHandler={this.state.stateLookupHandler}
                    enterKeyEventHandler={this.props.stateEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.statePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteStateList
                    }
                    showAutoCompleteList={this.props.showAutoCompleteStateList}
                    disabled={this.props.isDisabledFields}
                  />
                </Col>

                <Col sm="1">
                  {" "}
                  <FormLabel>Country</FormLabel>
                </Col>
                <Col sm="5">
                  {/* <InputTextbox
                    onChange={this.props.onChange}
                    name="country"
                    placeholder="country"
                    value={addressData.country}
                    lookupRequired={true}
                    lookupHandler={this.state.countryLookupHandler}
                    disabled={this.props.isDisabledFields}
                  ></InputTextbox> */}
                  <InputTextbox
                    name="country"
                    type="text"
                    placeholder="Enter Country"
                    value={addressData.country}
                    onChange={this.props.onCountryChange}
                    lookupRequired={true}
                    lookupHandler={this.state.countryLookupHandler}
                    enterKeyEventHandler={
                      this.props.countryEnterKeyEventHandler
                    }
                    autoCompleteListData={
                      this.props.countryPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.props.displayAutoCompleteCountryList
                    }
                    showAutoCompleteList={
                      this.props.showAutoCompleteCountryList
                    }
                    disabled={this.props.isDisabledFields}
                  />
                </Col>
              </Row>

              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Zip</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="zip"
                    type="text"
                    placeholder="Enter Zip"
                    onChange={this.props.onChange}
                    value={addressData.zip}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>ContactPerson</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="contactPerson"
                    type="text"
                    placeholder="Enter ContactPerson"
                    onChange={this.props.onChange}
                    value={addressData.contactPerson}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Mobile</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="mobilePhone"
                    type="text"
                    placeholder="Enter Mobile#"
                    onChange={this.props.onChange}
                    value={addressData.mobilePhone}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>

                <Col sm="1">
                  {" "}
                  <FormLabel>Phone</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="phone1"
                    type="text"
                    placeholder="Enter Phone#"
                    onChange={this.props.onChange}
                    value={addressData.phone1}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Email</FormLabel>
                </Col>
                <Col sm="5">
                  {" "}
                  <InputTextbox
                    name="email"
                    type="text"
                    placeholder="Enter Email"
                    onChange={this.props.onChange}
                    value={addressData.email}
                    disabled={this.props.isDisabledFields}
                  />{" "}
                </Col>
              </Row>
            </div>
            <div>
              {/* <Row>
                <Col className="so-align-items-left" sm="1">
                  <FormLabel>Roles</FormLabel> */}
              <Row>
                <Col sm="1">
                  <FormLabel>Roles</FormLabel>
                </Col>
              </Row>

              <div className="div_Custom_4">
                <Table id="fabrics_tables">
                  <thead>
                    <th>
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        className="enterFocus"
                        onClick={(e) => this.props.openRolePopupForm(e)}
                        disabled={this.props.isDisabledFields}
                      >
                        <AddIcon />
                      </Button>
                    </th>
                    <th>Role Code</th>
                    <th>Role Name</th>
                  </thead>
                  {!isEmptyArray(userData.userRoles) &&
                    userData.userRoles != null && (
                      <tbody>
                        {userData.userRoles.map((list, index) => (
                          <tr key={index}>
                            <td></td>
                            <td>
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.props.lnkRoleModule(e, list.roleCode)
                                }
                              >
                                {list.roleCode}
                              </Button>
                            </td>

                            <td>{list.description}</td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// class UserMaintenanceEntryFormBkup extends React.Component {
//   static contextType = AppContext;

//   constructor(props) {
//     super(props);

//     this.state = {
//       bankData: this.props.bankData,
//       isShowUserRolePopup: false,
//       selectRoleList: [],
//       availableRoleList: [],
//     };
//     this.userCodeRef = React.createRef();
//   }

//   componentDidMount() {
//     const { appData } = this.context;
//     this.companyCode = appData.companyCode;
//     this.initLookupHandlers();
//     this.setFocus();
//   }

//   componentDidUpdate() {
//     //
//   }
//   setFocus = () => {
//     //if(this.userCodeRef.current != null){
//     this.userCodeRef.current.focus();
//     //}
//   };
//   initLookupHandlers = () => {
//     let cityLookupHandler = new GenericAttributeLookupHandler(
//       this.props.cities,
//       "City"
//     );
//     this.setState({ cityLookupHandler: cityLookupHandler });

//     let stateLookupHandler = new GenericAttributeLookupHandler(
//       this.props.states,
//       "State"
//     );
//     this.setState({ stateLookupHandler: stateLookupHandler });

//     let countryLookupHandler = new GenericAttributeLookupHandler(
//       this.props.countries,
//       "Country"
//     );
//     this.setState({ countryLookupHandler: countryLookupHandler });
//   };

//   onChange = (e) => {
//     let temp_userdata = this.props.userData;
//     temp_userdata[e.target.name] = e.target.value;

//     let temp_addressData = this.props.addressData;
//     if (
//       e.target.name == "address1" ||
//       e.target.name == "address2" ||
//       e.target.name == "city" ||
//       e.target.name == "state" ||
//       e.target.name == "country" ||
//       e.target.name == "zip" ||
//       e.target.name == "mobilePhone" ||
//       e.target.name == "phone1" ||
//       e.target.name == "phone2" ||
//       e.target.name == "contactPerson" ||
//       e.target.name == "fax" ||
//       e.target.name == "email" ||
//       e.target.name == "website"
//     ) {
//       temp_addressData[e.target.name] = e.target.value;
//       temp_userdata[e.target.name] = e.target.value;
//     }
//     temp_userdata.address = temp_addressData;
//     this.setState({
//       userData: temp_userdata,
//       addressData: temp_addressData,
//     });
//   };

//   closeEntryForm() {
//     this.props.closeEntryForm();
//   }
//   openRolePopupForm = () => {
//     let userData = this.props.userData;
//     this.setState({ isShowUserRolePopup: true });
//     let selectRoleList = this.state.selectRoleList;
//     let availableRoleList = this.state.availableRoleList;
//     //  if (isEmptyArray(userData.userRoles)) {
//     let criteria = new RestRoleSearchCriteria();
//     let pageInput = new PageListBean();
//     pageInput.pageSize = 20;
//     pageInput.currentPageNumber = 1;

//     let listRequest = new RestRoleListRequest();
//     listRequest.searchCriteria = criteria;
//     listRequest.pageInput = pageInput;
//     SecurityService.getRolePageList(
//       listRequest,
//       this.loadRollPageResponse,
//       this.loadRollPageError
//     );
//     //  }
//     //else {
//     //   this.setState({ availableRoleList: availableRoleList });
//     // }
//   };
//   loadRollPageResponse = (response) => {
//     const availableRoleList = response.data.rolePageList.roles;
//     if (!isEmptyArray(availableRoleList)) {
//       this.setState({ availableRoleList: availableRoleList });
//     }
//   };
//   loadRollPageError = (error) => {
//     ShowError("Error", error);
//   };
//   closeAlertModalCallBack = (isShowPopup) => {
//     this.setState({
//       isShowUserRolePopup: isShowPopup,
//       isShowAlert: isShowPopup,
//     });
//   };
//   selectRoll = (val, rowData) => {
//     let selectRoleList = this.state.selectRoleList;
//     selectRoleList.push(rowData);
//     let availableRoleList = this.state.availableRoleList;
//     let avList = [];
//     availableRoleList
//       .filter((list) => list.code != rowData.code)
//       .map((dataList) => avList.push(dataList));
//     availableRoleList = avList;
//     this.setState({
//       selectRoleList: selectRoleList,
//       availableRoleList: availableRoleList,
//     });
//   };
//   unSelectRoll = (val, rowData) => {
//     let availableRoleList = this.state.availableRoleList;
//     availableRoleList.push(rowData);
//     let selectRoleList = this.state.selectRoleList;
//     let selList = [];
//     selectRoleList
//       .filter((list) => list.code != rowData.code)
//       .map((dataList) => selList.push(dataList));
//     selectRoleList = selList;
//     this.setState({
//       selectRoleList: selectRoleList,
//       availableRoleList: availableRoleList,
//     });
//   };
//   addSelectedRolls = () => {
//     let selectRoleList = this.state.selectRoleList;
//     let userData = this.props.userData;
//     let roleList = [];
//     //let userRoleData = null;
//     selectRoleList.map((data, index) => {
//       let userRoleData = new UserRoleBean();
//       userRoleData.userCode = userData.code;
//       userRoleData.roleCode = data.code;
//       userRoleData.description = data.description;
//       //roleList.push(userRoleData);
//       userData.userRoles.push(userRoleData);
//     });
//     // userData.userRoles = roleList;
//     this.setState({ userData: userData, isShowUserRolePopup: false });
//   };
//   render() {
//     let userData = this.props.userData;
//     let addressData = this.props.addressData;
//     let selectRoleList = this.state.selectRoleList;
//     let availableRoleList = this.state.availableRoleList;
//     return (
//       <div>
//         <div className="header_div col-md-12 col-lg-12">
//           <Row>
//             <Col sm="1">
//               <FormLabel> User Code </FormLabel>{" "}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 ref={this.userCodeRef}
//                 onChange={this.onChange}
//                 name="code"
//                 value={userData.code}
//               />
//             </Col>
//             <Col sm="1">
//               <FormLabel> FirstName</FormLabel>{" "}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="firstName"
//                 value={userData.firstName}
//               ></InputTextbox>
//             </Col>
//             <Col sm="1">
//               <FormLabel> LastName </FormLabel>{" "}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="lastName"
//                 value={userData.lastName}
//               ></InputTextbox>
//             </Col>
//             <Col sm="1">
//               <FormLabel> UserName</FormLabel>{" "}
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="description"
//                 value={userData.description}
//               ></InputTextbox>
//             </Col>
//           </Row>

//           <Row>
//             <Col sm="1">
//               {" "}
//               <FormLabel>Password</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 type="password"
//                 onChange={this.onChange}
//                 name="password"
//                 value={userData.password}
//               />
//             </Col>

//             <Col sm="1">
//               {" "}
//               <FormLabel>Confirm Password</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 type="password"
//                 onChange={this.onChange}
//                 name="password"
//                 value={userData.password}
//               />
//             </Col>

//             <Col sm="1">
//               {" "}
//               <FormLabel>Employee Code</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="entityCode"
//                 value={userData.entityCode}
//               />
//             </Col>

//             <Col sm="1">
//               {" "}
//               <FormLabel>CompanyCode</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="companyCode"
//                 value={userData.companyCode}
//                 disabled={true}
//               />
//             </Col>
//           </Row>

//           <Row>
//             <Col sm="1">
//               {" "}
//               <FormLabel>SMTP UserName</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="smtpUserName"
//                 value={userData.smtpUserName}
//               />
//             </Col>

//             <Col sm="1">
//               {" "}
//               <FormLabel>SMTP Password</FormLabel>
//             </Col>
//             <Col sm="2">
//               <InputTextbox
//                 onChange={this.onChange}
//                 name="smtpPassword"
//                 value={userData.smtpPassword}
//               />
//             </Col>
//           </Row>
//         </div>

//         <div className="header_div">
//           <div className="sales_grid_columns">
//             <div>
//               <Row>
//                 <FormLabel>Address</FormLabel>
//               </Row>
//               <Row>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Address1</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="address1"
//                     type="text"
//                     placeholder="Enter Address"
//                     onChange={this.onChange}
//                     value={addressData.address1}
//                   />{" "}
//                 </Col>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>City</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   <InputTextbox
//                     onChange={this.onChange}
//                     ref={this.cityRef}
//                     name="city"
//                     placeholder="city"
//                     value={addressData.city}
//                     lookupRequired={true}
//                     lookupHandler={this.state.cityLookupHandler}
//                   ></InputTextbox>
//                 </Col>
//               </Row>

//               <Row>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>State</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   <InputTextbox
//                     onChange={this.onChange}
//                     ref={this.stateRef}
//                     name="state"
//                     placeholder="state"
//                     value={addressData.state}
//                     lookupRequired={true}
//                     lookupHandler={this.state.stateLookupHandler}
//                   ></InputTextbox>
//                 </Col>

//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Country</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   <InputTextbox
//                     onChange={this.onChange}
//                     ref={this.countryRef}
//                     name="country"
//                     placeholder="country"
//                     value={addressData.country}
//                     lookupRequired={true}
//                     lookupHandler={this.state.countryLookupHandler}
//                   ></InputTextbox>
//                 </Col>
//               </Row>

//               <Row>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Zip</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="zip"
//                     type="text"
//                     placeholder="Enter Zip"
//                     onChange={this.onChange}
//                     value={addressData.zip}
//                   />{" "}
//                 </Col>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>ContactPerson</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="contactPerson"
//                     type="text"
//                     placeholder="Enter ContactPerson"
//                     onChange={this.onChange}
//                     value={addressData.contactPerson}
//                   />{" "}
//                 </Col>
//               </Row>
//               <Row>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Mobile</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="mobilePhone"
//                     type="text"
//                     placeholder="Enter Mobile#"
//                     onChange={this.onChange}
//                     value={addressData.mobilePhone}
//                   />{" "}
//                 </Col>

//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Phone</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="phone1"
//                     type="text"
//                     placeholder="Enter Phone#"
//                     onChange={this.onChange}
//                     value={addressData.phone1}
//                   />{" "}
//                 </Col>
//               </Row>
//               <Row>
//                 <Col sm="1">
//                   {" "}
//                   <FormLabel>Email</FormLabel>
//                 </Col>
//                 <Col sm="5">
//                   {" "}
//                   <InputTextbox
//                     name="email"
//                     type="text"
//                     placeholder="Enter Email"
//                     onChange={this.onChange}
//                     value={addressData.email}
//                   />{" "}
//                 </Col>
//               </Row>
//             </div>
//             <div>
//               <Row>
//                 <Col className="so-align-items-left" sm="1">
//                   <FormLabel>Roles</FormLabel>
//                   <Col>
//                     <ShortCutMenuPopup
//                       value={userData.userRoles}
//                       menuItems={
//                         <ul>
//                           <li
//                             className="shortcut-menu-item"
//                             onClick={this.openRolePopupForm}
//                           >
//                             {" "}
//                             Add Multiple Role{" "}
//                           </li>
//                         </ul>
//                       }
//                     />
//                   </Col>
//                 </Col>
//               </Row>
//               <Row>
//                 <Table>
//                   <thead>
//                     <th>Role Code</th>
//                     <th>Role Name</th>
//                   </thead>
//                   {!isEmptyArray(userData.userRoles) &&
//                     userData.userRoles != null && (
//                       <tbody>
//                         {userData.userRoles.map((list, index) => (
//                           <tr key={index}>
//                             <td>
//                               <Button
//                                 variant="secondry"
//                                 className="hyperLinkText"
//                               >
//                                 {list.roleCode}
//                               </Button>
//                             </td>

//                             <td>{list.description}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     )}
//                 </Table>
//               </Row>
//             </div>
//           </div>
//         </div>
//         <SimplePopup
//           isShowPopup={this.state.isShowUserRolePopup}
//           closeOnEsc={false}
//           closeAlertModalCallBack={this.closeAlertModalCallBack}
//           title={"Add Multiple Roll"}
//           closeOnDocumentClick={false}
//           lineFunctionalityForm={this.lineFunctionalityForm}
//           headerButtonContainer={
//             <div className="floatLeft">
//               <Button
//                 className="header_buttons enterFocus"
//                 onClick={() => this.addSelectedRolls()}
//               >
//                 Add
//               </Button>
//             </div>
//           }
//           content={
//             <div className="sales_line_pop">
//               <FormLabel>Available Roles</FormLabel>
//               <Table>
//                 <thead>
//                   <th> </th>
//                   <th>Role Code</th>
//                   <th>Role Name</th>
//                 </thead>
//                 {!isEmptyArray(availableRoleList) && (
//                   <tbody>
//                     {availableRoleList.map((list, index) => (
//                       <tr key={index}>
//                         <td>
//                           <Button
//                             size="sm"
//                             variant="secondary"
//                             onClick={() => this.selectRoll(list.code, list)}
//                           >
//                             Select+
//                           </Button>
//                         </td>
//                         <td>{list.code}</td>
//                         <td>{list.description}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 )}
//               </Table>
//               <FormLabel>Selected Roles</FormLabel>
//               <Table>
//                 <thead>
//                   <th> </th>
//                   <th>Role Code</th>
//                   <th>Role Name</th>
//                 </thead>

//                 {!isEmptyArray(selectRoleList) && (
//                   <tbody>
//                     {selectRoleList.map((list, index) => (
//                       <tr key={index}>
//                         <td>
//                           <Button
//                             size="sm"
//                             variant="secondary"
//                             onClick={() => this.unSelectRoll(list.code, list)}
//                           >
//                             UnSelect+
//                           </Button>
//                         </td>
//                         <td>{list.code}</td>
//                         <td>{list.description}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 )}
//               </Table>
//             </div>
//           }
//         />
//       </div>
//     );
//   }
// }
function UserMaintenanceModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <UserMaintenance {...props} name="" /> <br />
    </div>
  );
}
export default UserMaintenanceModule;
